<template>
  <v-snackbar v-model="show" :top="top" :color="color">
    <v-icon v-if="color === 'success'" left>mdi-check</v-icon>
    {{message}}
    <template v-slot:action="{ attrs }">
      <v-btn v-if="$helpers.display.isMobile" icon v-bind="attrs" @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
      <v-btn v-else text v-bind="attrs" @click="show = false">{{ $t('close') }}</v-btn>
    </template>
  </v-snackbar>

</template>

<script>
export default {
  data() {
    return {
      show: false,
      top: true,
      message: "",
      color: "",
      timeout: 5000,
    };
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "snackbar/show") {
        this.message = state.snackbar.snack.message;
        this.color = state.snackbar.snack.color ?? "success";
        this.show = true;
      }
    });
  },
};
</script>